import api from "@/axios";
import type { AxiosResponse } from "axios";
import type { Supplier, AddPricing, FireTestSupplier, QualityCheckSupplier } from '@/types/supplier-types'

export const addSupplier = async (data: Supplier): Promise<AxiosResponse> => {
    const response = await api.post('/suppliers', data);
    return response.data;
}

export const addSupplierPricingToSupplier = async (id: string, data: AddPricing): Promise<AxiosResponse> => {
    const response = await api.post(`/suppliers/${id}/add-pricing`, data);
    return response.data;
}

export const getSupplierList = async (): Promise<Supplier[]> => {
    const response = await api.get("/suppliers");
    return response.data;
}

export const getSupplierById = async (id: string): Promise<Supplier> => {
    const response = await api.get(`/suppliers/${id}`);
    return response.data;
}

export const editSupplier = async (data: Supplier, id: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/suppliers/${id}`, data);
    return response.data;
}
export const updateSupplierPricing = async (data: AddPricing, supplierId: string, supplierPricingId: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/suppliers/${supplierId}/pricings/${supplierPricingId}`, data);
    return response.data;
}

export const getSuppliersByQualityId = async (id: string): Promise<Supplier[]> => {
    const response = await api.get(`/suppliers/quality/${id}`);
    return response.data;
}

export const getFireTestSuppliers = async (): Promise<FireTestSupplier[]> => {
    const response = await api.get(`/suppliers/fire-test`);
    return response.data;
  };

export const getQualityCheckSuppliers = async (): Promise<QualityCheckSupplier[]> => {
    const response = await api.get(`/suppliers/quality-check`);
    return response.data;
}

export const deleteSupplierPricing = async (supplierId: string, supplierPricingId: string): Promise<AxiosResponse> => {
    const response = await api.delete(`/suppliers/${supplierId}/pricing/${supplierPricingId}`);
    return response.data;
}